import { useTranslation } from 'react-i18next'

import Button from '../../Button'
import { useFileDownload } from '../../File'

import * as styles from './FilePreview.module.css'

import DownloadIcon from '../../../icons/export.svg'

function FilePreview({
  className = styles.FilePreview,
  downloadFileDocument,
  file,
  scope,
  subject,
}) {
  const { t } = useTranslation()

  const { downloadFile } = useFileDownload({
    apiParams: {
      object_id: subject,
      scope,
    },
    downloadFileDocument,
    file,
  })

  function handleClick() {
    downloadFile()
  }

  return (
    <div className={className}>
      <span className={styles.message}>{t('Files.PreviewNotAvailable')}</span>
      <Button.Contained
        beforeIconProps={{ Icon: DownloadIcon }}
        className={styles.button}
        text={t('Files.Download')}
        onClick={handleClick}
      />
    </div>
  )
}

export default FilePreview
